import React, { useState, useEffect, memo } from 'react';
import { useParams } from 'react-router-dom';

import {
  StartCampaignActionButtons,
  StartCampaignHeader,
  StartCampaignTable,
  CampaignSettings,
  ConvertOnTheSpotView,
  ReminderView,
  CustomView,
  ChooseMediaView,
  ChoosedMediaView,
  ApprovedMessagesView,
  AddNewView,
  NurtureToAppointment,
  EditTemplateView,
} from './components';
import { useAppData } from '../../context/AppContext';
import {
  campaignViewValues,
  StartCampaignConfigProps,
  StartCampaignConfig,
} from '../../config/CampaignsConfig';
import { CampaignDataProps } from './components/startCampaignModels';
import { getCampaignById } from '../../core/requests/requests';

const StartCampaign: React.FC = () => {
  const {
    currentStartCampaignView,
    setCurrentStartCampaignView,
    setCurrentCampaign,
  } = useAppData();
  const { campaignId } = useParams<{ campaignId: string }>();
  const [currentMessageType, setCurrentMessageType] = useState<string | null>(
    null
  );
  const [currentCampaignConfig, setCurrentCampaignConfig] =
    useState<StartCampaignConfigProps | null>(null);
  const [campaignData, setCampaignData] = useState<CampaignDataProps | null>(
    null
  );

  useEffect(() => {
    const fetchCampaign = async () => {
      try {
        if (campaignId) {
          const { data } = await getCampaignById(campaignId);
          setCampaignData(data);
          setCurrentCampaign(data);
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchCampaign();
  }, [campaignId]);

  useEffect(() => {
    const currentViewConfig = () => {
      return StartCampaignConfig.filter(
        (config) => config.value === currentStartCampaignView
      )[0];
    };

    const currentConfig = currentViewConfig();
    setCurrentCampaignConfig(currentConfig);
  }, [currentStartCampaignView]);

  useEffect(() => {
    const savedView = sessionStorage.getItem('currentStartCampaignView');
    if (savedView) {
      setCurrentStartCampaignView(savedView); // Restore the view from session storage
      sessionStorage.removeItem('currentStartCampaignView'); // Clean up the session storage
    }
  }, []);

  return (
    <div className="p-1_875rem">
      <div className="d-flex-start-start b-radius-0_5rem p-1_5rem shadow-box-1 shadow-box-2 bg-white w-100">
        <StartCampaignHeader
          currentCampaignConfig={currentCampaignConfig}
          campaignDataId={campaignData?.id ? campaignData?.id : null}
        />
        {currentStartCampaignView === campaignViewValues?.startCampaign && (
          <ConvertOnTheSpotView setCurrentMessageType={setCurrentMessageType} />
        )}
        {currentStartCampaignView === campaignViewValues?.convertOnTheSpot && (
          <ConvertOnTheSpotView setCurrentMessageType={setCurrentMessageType} />
        )}
        {currentStartCampaignView === campaignViewValues?.appointment && (
          <NurtureToAppointment setCurrentMessageType={setCurrentMessageType} />
        )}
        {currentStartCampaignView === campaignViewValues?.reminder && (
          <ReminderView setCurrentMessageType={setCurrentMessageType} />
        )}
        {currentStartCampaignView === campaignViewValues?.custom && (
          <CustomView />
        )}

        {(currentStartCampaignView === campaignViewValues?.instagram ||
          currentStartCampaignView === campaignViewValues?.facebook ||
          currentStartCampaignView === campaignViewValues?.whatsapp ||
          currentStartCampaignView === campaignViewValues?.sms) && (
          <ChoosedMediaView />
        )}
        {currentStartCampaignView === campaignViewValues?.approved_messages && (
          <ApprovedMessagesView currentMessageType={currentMessageType} />
        )}
        {currentStartCampaignView === campaignViewValues?.add_new && (
          <AddNewView
            currentMessageType={currentMessageType ? currentMessageType : null}
          />
        )}
        {currentStartCampaignView === campaignViewValues?.edit && (
          <EditTemplateView />
        )}
        {currentStartCampaignView === campaignViewValues?.chooseMedia && (
          <ChooseMediaView />
        )}
        {currentCampaignConfig?.showLeads && <StartCampaignTable />}
        {currentStartCampaignView === campaignViewValues?.settings && (
          <CampaignSettings
            campaignData={campaignData}
            setCampaignData={setCampaignData}
          />
        )}
      </div>
    </div>
  );
};

export default memo(StartCampaign);
